import React, {Component} from 'react';

export default class SliderViewer extends Component {
  render() {
    const {value} = this.props;

    return (
      <progress className="progress slider-viewer" value={value} max="100"/>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/technologyComfort/sliderGroup/sliderField/SliderViewer.jsx